import { Controller } from 'stimulus';
import { render, h } from 'preact';
import { useState, useEffect } from 'preact/hooks';

const RangeIndicator = ({ startText, endText, startValuePresent, endValuePresent, startValueCalculation, endValueCalculation,unit, value, totalWidth }) => {
  const [indicatorOffset, setOffset] = useState(0);

  useEffect(() => {
    const offsetRatio = Math.min(Math.max((value - startValueCalculation) / (endValueCalculation - startValueCalculation), 0), 1);
    setOffset(offsetRatio * totalWidth)
  }, [startValueCalculation, endValueCalculation, value, totalWidth])

  return (
    <div className="t-flex t-flex-col">
      <svg style={{ transform: `translateX(${ indicatorOffset - 4}px)`}} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.43301 7.25C4.24056 7.58333 3.75944 7.58333 3.56699 7.25L0.102886 1.25C-0.0895637 0.916668 0.150998 0.500001 0.535899 0.500001L7.4641 0.500001C7.849 0.500001 8.08957 0.916668 7.89711 1.25L4.43301 7.25Z" fill="#2532D0" />
      </svg>
      <div className="t-w-full t-bg-mitre-gray-250 t-h-1" style="border-radius: 10px;"/>
      <div className="t-flex t-justify-between">
        <p className="t-text-2xs t-mb-0 t-text-mitre-gray-300">
          {`${startText}: ${unit}${startValuePresent}`}
        </p>
        <p className="t-text-2xs t-mb-0 t-text-mitre-gray-300">
          {`${endText}: ${unit}${endValuePresent}`}
        </p>
      </div>
    </div>
  )
}

class RangeIndicatorController extends Controller {
  connect() {
    const rangeStartText = this.data.get('start-text')
    const rangeEndText = this.data.get('end-text')
    const rangeStartValuePresent = this.data.get('start-value')
    const rangeEndValuePresent = this.data.get('end-value')
    const rangeStartValueCalculation = this.data.get('start-value-calculation') || rangeStartValue
    const rangeEndValueCalculation = this.data.get('end-value-calculation') || rangeEndValue
    const rangeUnit = this.data.get('unit') 
    const rangeValue = parseFloat(this.data.get('value'));
    const { width } = this.element.getBoundingClientRect();

    render(
      <RangeIndicator
        startText={rangeStartText}
        endText={rangeEndText}
        startValuePresent={rangeStartValuePresent}
        endValuePresent={rangeEndValuePresent}
        startValueCalculation={rangeStartValueCalculation}
        endValueCalculation={rangeEndValueCalculation}
        unit={rangeUnit}
        value={rangeValue}
        totalWidth={width}
      />,
      this.element
    )
  }
}

export default RangeIndicatorController;
